import { Icon } from '../Icon';
import type { IconProps } from '../Icon/Icon';

export type CollapsibleTriggerIconProps = Omit<IconProps, 'type'> & {
  type: Extract<
    IconProps['type'],
    'caret-left-strong' | 'caret-left' | 'caret-right-strong' | 'caret-right' | 'plus'
  >;
};

const iconRotationMap = {
  'caret-left-strong': '-90',
  'caret-left': '-90',
  'caret-right-strong': '90',
  'caret-right': '90',
  plus: '45',
} as const;

export const CollapsibleTriggerIcon = ({ type, ...props }: CollapsibleTriggerIconProps) => {
  return (
    <Icon
      {...props}
      data-wui-collapsible-icon="true"
      data-wui-collapsible-icon-rotate={iconRotationMap[type]}
      type={type}
    />
  );
};

CollapsibleTriggerIcon.displayName = 'CollapsibleTriggerIcon';
